const plusMinutes = (dateTime, minutes) => dateTime.plus({ minutes });

export default plusMinutes;
